import DeliveryDaySchedules from 'pared/aiBlackbox/fw_wingstop/DeliveryDaySchedules'
import ManualDataCorrection from 'pared/aiBlackbox/fw_wingstop/ManualDataCorrection'
import PrepItemAdminSetting from 'pared/aiBlackbox/fw_wingstop/PrepItemAdminSetting'
import PrepItemCalculator from 'pared/aiBlackbox/fw_wingstop/PrepItemCalculator'
import PrepItemConfiguration from 'pared/aiBlackbox/fw_wingstop/PrepItemConfiguration'

import { IAiBlackboxProps } from '../type'

export default function getFwWingstopContent(
  contentPartName: string,
): React.FC<IAiBlackboxProps> | null {
  switch (contentPartName) {
    case 'fwWingstopManualDataCorrection':
      return ManualDataCorrection
    case 'fwWingstopPrepItemConfiguration':
      return PrepItemConfiguration
    case 'fwWingstopPrepItemCalculator':
      return PrepItemCalculator
    case 'fwWingstopPrepItemAdminSetting':
      return PrepItemAdminSetting
    case 'fwWingstopDeliveryDaySchedules':
      return DeliveryDaySchedules
    default:
      return null
  }
}
